import Layout from '@/layout';
var approvalRouter = {
  path: '/approval',
  component: Layout,
  redirect: '/approval/myApproval',
  name: 'Approval',
  meta: {
    title: '我的审批',
    icon: 'clipboard'
  },
  children: [{
    path: 'myApproval',
    component: function component() {
      return import('@/views/approval/myApproval');
    },
    name: 'MyApproval',
    meta: {
      title: '我发起的审批',
      icon: ''
    }
  }, {
    path: 'myCc',
    component: function component() {
      return import('@/views/approval/myCc');
    },
    name: 'MyCc',
    meta: {
      title: '我收到的抄送',
      icon: ''
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return import('@/views/approval/approvalDetail');
    },
    name: 'ApprovalDetail',
    hidden: true,
    meta: {
      title: '审批详情',
      activeMenu: '/approval/myApproval'
    }
  }]
};
export default approvalRouter;